module.exports = __webpack_public_path__ + "img/qy (50).a9e0fb02.jpg";